import { httpStatuses } from '@reveni-io/reveni-ui'

export const omitFields = (values, fields) => {
  return Object.fromEntries(Object.entries(values).filter(([field]) => !fields.includes(field)))
}

export const getFieldErrors = error => {
  if (error.response?.status !== httpStatuses.badRequest) return {}

  return error.response.data
}
